import React, { useState } from 'react'
import ProfileLoginDetail from '../../components/profileLoginDetail/profileLoginTab/ProfileLoginDetail';
import AccountLoginTab from '../../components/profileLoginDetail/accountLoginTab/AccountLoginTab';
import WalletLoginTab from '../../components/profileLoginDetail/walletLoginTab/WalletLoginTab';
import BlockedLoginTab from '../../components/profileLoginDetail/blockedLoginTab/BlockedLoginTab';
import InsightsLoginTab from '../../components/profileLoginDetail/insightsLoginTab/InsightsLoginTab';
import ReportLoginTab from '../../components/profileLoginDetail/reportLoginTab/ReportLoginTab';
import SubscriptionLoginTab from '../../components/profileLoginDetail/subscriptionLoginTab/SubscriptionLoginTab';

const ProfilLogin = () => {
    const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
    return (
      
    <div className='dashboard-content-box dashboard-profile-content-box p-0'>
      <div className="tabs-container profile-sec">
        <div className='innerProfile-sec d-flex flex-wrap'>
          <div className="tabs-header sticky-md-top ">
            <button className={`tab-button ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}> Profile </button>
            <button className={`tab-button ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}> Account </button>
            <button className={`tab-button ${activeTab === 2 ? "active" : ""}`} onClick={() =>  setActiveTab(2)}> Wallet </button>
            <button className={`tab-button ${activeTab === 3 ? "active" : ""}`} onClick={() =>  setActiveTab(3)}> Blocked </button>
            {/* <button className={`tab-button ${activeTab === 4 ? "active" : ""}`} onClick={() =>  setActiveTab(4)}> Insights </button> */}
            <button className={`tab-button ${activeTab === 5 ? "active" : ""}`} onClick={() =>  setActiveTab(5)}> Analytics </button>
            <button className={`tab-button ${activeTab === 6 ? "active" : ""}`} onClick={() =>  setActiveTab(6)}> Subscription </button>
          </div>
  
          <div className="tabs-content profileTabsSec">
            {activeTab === 0 && (
                <div className="tab-panel">
                   <ProfileLoginDetail />
                </div>
            )}
            {activeTab === 1 && (
                <div className="tab-panel">
                  <AccountLoginTab />
                </div>
            )}
            {activeTab === 2 && (
                <div className="tab-panel">
                  <WalletLoginTab />
                </div>
            )}
            {activeTab === 3 && (
                <div className="tab-panel">
                  <BlockedLoginTab />
                </div>
            )}
            {/* {activeTab === 4 && (
                <div className="tab-panel">
                  <InsightsLoginTab />
                </div>
            )} */}
            {activeTab === 5 && (
                <div className="tab-panel">
                  <ReportLoginTab />
                </div>
            )}
            {activeTab === 6 && (
                <div className="tab-panel">
                  <SubscriptionLoginTab />
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
    )
}

export default ProfilLogin
